import info from './info'
import menu from './menu'
import table from './table'

export default {
    organisationId: 'Lieferant {id}',
    history: 'Historie',

    logo: 'Logo',
    name: 'Name',
    email: 'E-Mail',
    address: 'Anschrift',
    street: 'Straße',
    housenumber: 'Hausnummer',
    zipcode: 'PLZ',
    city: 'Ort',
    country: 'Land',
    membersCount: 'Mitglieder',
    organisationUsers: 'Ansprechpersonen',
    category: 'Abonnierte Kategorien',
    categories: 'Kategorien',
    subscriptions: 'Keine Kategorie abonniert|Eine Kategorie abonniert|{count} Kategorien abonniert',
    searchCategory: 'Kategorie suchen',
    categoryDescription: 'Über die Kategorien wird bestimmt, zu welchen Beschaffungen Sie als Ansprechperson benachrichtigt werden.',

    removeSupplier: 'Ansprechperson entfernen',
    removeSupplierInfo: 'Möchtest du diese Ansprechperson wirklich vom Lieferanten entfernen?\nDie Ansprechperson bleibt für alte Beschaffungen im System weiterhin bestehen, kann aber nicht mehr ausgewählt werden und hat ab sofort keinen Zugriff auf BEMA.',
    createUserSuccess: 'Die Ansprechperson wurde erfolgreich erstellt.',
    createUserError: 'Die Ansprechperson konnte nicht erstellt werden.',
    storeUserSuccess: 'Die Ansprechperson wurde erfolgreich angelegt.',
    storeUserError: 'Die Ansprechperson konnte nicht angelegt werden.',
    updateUserSuccess: 'Die Ansprechperson wurde erfolgreich aktualisiert.',
    updateUserError: 'Die Ansprechperson konnte nicht aktualisiert werden.',
    removeUserSuccess: 'Die Ansprechperson wurde erfolgreich entfernt.',
    removeUserError: 'Der Nutzer konnte nicht entfernt werden.',
    invitationLinkCopied: 'Der Einladungslink wurde in die Zwischenablage kopiert.',

    organisationSelect: 'Lieferantenauswahl',
    searchOrganisation: 'Organisation suchen',
    supplierSelect: 'Ansprechpersonenauswahl',
    selectSupplier: 'Ansprechperson auswählen',

    createUser: 'Ansprechperson hinzufügen',
    updateUser: 'Ansprechperson bearbeiten',

    invitePerLink: 'Ansprechperson per Link einladen',
    invitePerMail: 'per Mail',
    createInvitationLink: 'Anmeldelink generieren',

    invitationLinkGenerating: 'Der Einladungslink wird generiert...',
    inviteSubject: '[BEMA] Einladung als Ansprechperson für {organisation}',
    inviteBody: 'Guten Tag,\n\n{link}\n\nMit freundlichen Grüßen\nIhr BEMA-Team',

    createSupplierDescription: 'Legen Sie hier eine neue Ansprechperson für den aktuellen Lieferanten an. Diese kann dann von allen Mitarbeitern als Ansprechperson ausgewählt werden.',

    createOrganisation: 'Neuen Lieferant "{name}" anlegen',
    organisationHasOffer: 'Für den Lieferant "{name}" wurde bereits ein Angebot hinterlegt.',
    searchForOrganisation: 'Geben Sie den Namen Ihres Lieferanten ein',
    noOrganisationFound: 'Kein Lieferant gefunden',
    createOrganisationSuccess: 'Der Lieferant wurde erfolgreich erstellt.',
    createOrganisationError: 'Der Lieferant konnte nicht erstellt werden.',

    createSupplierAction: 'Ansprechperson anlegen',
    createSupplier: 'Neue Ansprechperson anlegen',
    searchForSupplier: 'Geben Sie den Namen Ihrer Ansprechperson ein',
    noSupplierFound: 'Keine Ansprechperson gefunden',
    createSupplierSuccess: 'Die Ansprechperson wurde erfolgreich erstellt.',
    createSupplierError: 'Die Ansprechperson konnte nicht erstellt werden.',

    deleteOrganisation: 'Lieferant löschen',
    deleteOrganisationText:
        'Möchtest du die Organisation wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    deleteOrganisationSuccess: 'Lieferant wurde erfolgreich gelöscht.',
    deleteOrganisationError: 'Der Lieferant konnte nicht gelöscht werden.',

    toggleState: 'aktivieren / deaktivieren',
    toggleStateSuccess: 'Status wurde erfolgreich geändert.',
    toggleStateError: 'Der Status konnte nicht geändert werden.',

    supplierAccess: {
        access: 'Hat Nutzerzugriff auf BEMA',
        noAccess: 'Kein Zugriff auf BEMA'
    },
    organisationAccess: {
        access: 'Organisation hat Zugriff auf BEMA',
        noAccess: 'Organisation hat keinen Zugriff auf BEMA',
        receivesMails: 'Erhält E-Mails zu bestimmten Anfragen',
        receivesNoMails: 'Erhält keine E-Mails zu Anfragen',
    },
    shortAccess: {
        access: 'Zugriff',
        noAccess: 'Kein Zugriff'
    },

    info,
    menu,
    table
}